module.exports = __webpack_public_path__ + "static/media/elan-header-logo.61dfb6e8.png";